import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import styled from "styled-components";
// import { FormGroup as ReactFormGroup, Label as ReactLabel } from "@vzrf/react-forms";
import { Redirect } from "react-router-dom";
import { checkNestedObject } from "utils/checkNestedObject";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import { Input as ReactInput, Select as ReactSelect } from "common-components/FormContent";
import { Tooltip as ReactTooltip } from "common-components/Tooltip";
import Button from "common-components/Buttons";

class AppealForm extends Component {
  componentDidMount() {


  }

  entityNumberValid = val => {
    if (val.length !== 8 && val.length !== 12) {
      return "Invalid entity number";
    }
    if (val.length === 8) {
      if (val.charAt(0).toLowerCase() !== "c") {
        return "Invalid entity number";
      }
    }
  };

  required = (value, ...label) => {

    if (value === "Select option" || value === "Seleccionar opción") {
      const appeal_details = this.props.content;
      const { genericList } = appeal_details;
      return genericList[0].startTextError;
    }

    if (value || typeof value === "number") {
      return undefined;
    }

    if (label && label[2]) {
      const el = document.querySelectorAll(`[for='${label[2]}']`);
      if (el && el[0]) {
        return `${el[0].textContent} is required.`;
      }
    }
    return "Required.";
  };

  renderField = ({
    input,
    autoComplete,
    type,
    width,
    maxLength,
    content,
    marginBottom,
    marginTop,
    meta: { touched, error },
    ...extra
  }) => {

    const appeal_details = this.props.content;
    const {
      genericList: [{ list: appealReaonsList }]
    } = appeal_details;

    const commonProps = {
      id: input.name,
      error: touched && error,
      autoComplete: autoComplete ? autoComplete : "on",
      "aria-describedby": `${input.name}_error`,
      ...extra
    };

    return (
      <Form width={width} marginBottom={marginBottom} marginTop={marginTop}>
        <label htmlFor={input.name}>
          {content}
        </label>
        {type === "select" ? (
          <Select {...input} {...commonProps}>
            {appealReaonsList.map(appealReaon => (
              <option key={appealReaon.jsonKey} value={appealReaon.jsonValue}>
                {appealReaon.jsonValue}
              </option>
            ))}
          </Select>
        ) : (
          <Input
            {...input}
            {...commonProps}
            onKeyPress={e => {
              this.props.invalid && e.key === "Enter" && e.preventDefault();
            }}
            maxLength={maxLength ? maxLength : "50"}
          />
        )}
        {touched && error && (
          <ErrorMsg role="alert" id={`${input.name}_error`}>
            {error}
          </ErrorMsg>
        )}
      </Form>
    );
  };

  handleCancelClick = () => {
    this.props.onCancel();
  };

  render() {
    if (!checkNestedObject(this.props, "content")) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    const appeal_details = this.props.content;
    const { genericList, buttons } = appeal_details;

    return (
      <Form onSubmit={this.props.onSubmit}>
        <fieldset>
          {/*<Legend>{genericList[0].text}</Legend>*/}
          <Field
            component={this.renderField}
            validate={[this.required]}
            type="select"
            name="appealReason"
            content={genericList[0].text}
            marginBottom={20}
            width={32}
          />
          {
            undefined !== this.props.appealForm && undefined !== this.props.appealForm.values && this.props.appealForm.values.appealReason === "Other"
              ?
              <>
                <Field
                  component={this.renderField}
                  validate={[this.required]}
                  name="appealReasonOther"
                  maxLength="500"
                  content={genericList[0].endText}
                  marginTop={40}
                  marginBottom={12}
                />
                <p style={{ maxWidth: "350px", fontSize: "12px", marginBottom: "24px" }}>{convertStringToElements(genericList[0].customDescription)}</p>
              </>
              :
              ""
          }
        </fieldset>
        <ButtonContainer>
          <Button
            type="submit"
            disabled={this.props.invalid}
            background={buttons[0].type}
          >
            {buttons[0].text}
          </Button>

          <Button type="button" onClick={this.handleCancelClick} background="white_background">
            {buttons[1].text}
          </Button>
        </ButtonContainer>

      </Form>
    );
  }
}

const mapStateToProps = ({
  form: { appealForm },
  pageContent
}) => ({
  appealForm,
  pageContent
});

AppealForm = reduxForm({
  form: "appealForm",
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true
})(AppealForm);

AppealForm = connect(
  mapStateToProps,
  {}
)(AppealForm);

export default AppealForm;

const Tooltip = styled(ReactTooltip)`
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
`;

const Form = styled.form`
  max-width: 385px;
  /*border-top: 4px solid #000;*/
  padding-top: 2px;
`;

const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  ${media.mobile`
   flex-direction: column;
  `}
`;

// const Label = styled(ReactLabel)`
//   color: #747676;
//   font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
//   font-size:12px;
//   margin-bottom:8px;
// `;


// const FormGroup = styled(ReactFormGroup)`
//   width: 100%;
//   margin-bottom: 40px;
//   ${({ marginBottom }) =>
//     marginBottom &&
//     `
//     margin-bottom: ${marginBottom}px;
//   `}

//   ${({ marginTop }) =>
//     marginTop &&
//     `
//     margin-top: ${marginTop}px;
//   `}

//   ${({ width }) =>
//     width &&
//     `
//     flex-basis: ${width}%;
//   `}  
// `;

const Input = styled(ReactInput)`
  width: 100%;
  max-width: 100%;
`;

const Select = styled(ReactSelect)`
  width: 100% !important;
  padding: 12px !important;
  min-width: inherit !important;
  height: inherit !important;
`;

const Legend = styled.legend`
  font-size: 14px;
  line-height: 14.5px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  margin-bottom: 14px;
`;

const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  max-width: 173px;
  margin-top: 5px;

  ${media.mobile`
    max-width: 100%;  
  `}
`;
